module.exports = __webpack_public_path__ + "img/EmptyState.28d22a4d.svg";